var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpPinLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b91bd04a-a3c5-4806-bdf9-52107611b7ae",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.53 52.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.28,1.51A18.24,18.24,0,0,0,3,19.75c0,.69,0,1.38.1,2.09A39.09,39.09,0,0,0,6,32.78Q7,35,8,37.15H8a16.49,16.49,0,0,1,26.49,0h0c.71-1.43,1.38-2.9,2-4.37a39.09,39.09,0,0,0,2.93-10.94c.07-.71.1-1.4.1-2.09A18.24,18.24,0,0,0,21.28,1.51Z",
    transform: "translate(-3.01 -1.51)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.28,13.12a7.43,7.43,0,1,0,5.25,2.18A7.4,7.4,0,0,0,21.28,13.12Z",
    transform: "translate(-3.01 -1.51)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.51,37.15A16.49,16.49,0,0,0,8,37.15l0,0a109,109,0,0,0,9,14.79h0a5.18,5.18,0,0,0,8.42,0h0a109,109,0,0,0,9-14.79Z",
    transform: "translate(-3.01 -1.51)",
    style: {
      fill: "#b4e1fa"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpPinLight);
export default __webpack_public_path__ + "static/media/pp-pin-light.79b73d52.svg";
export { ForwardRef as ReactComponent };